import React, { Component } from "react";
import PageHelmet from "../../component/common/Helmet";
import ModalVideo from 'react-modal-video';
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../../component/header/Header";
import FooterTwo from "../../component/footer/FooterTwo";


interface Props {}

interface State {
    isOpen: boolean;
}

class Atourin extends Component<Props, State>{
    constructor (props: Props) {
        super(props)
        this.state = {
          isOpen: false
        }
        this.openModal = this.openModal.bind(this)
    }
    openModal () {
        this.setState({isOpen: true})
    }
    render(): React.ReactNode{
        return(
            <React.Fragment>
                
                {/* Start Pagehelmet  */}
                <PageHelmet pageTitle='Project Details' />
                {/* End Pagehelmet  */}

                <Header headertransparent="header--transparent" colorblack="color--white" logoname="logo.png" />

                {/* Start Breadcrump Area */}
                <div className="rn-page-title-area pt--120 pb--190" style={{ backgroundImage: `url("/assets/images/banner-bg.jpg")` }}  >
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="rn-page-title text-center pt--100">
                                    <h2 className="title theme-color ">Atourin</h2>
                                    <p>Mobile App</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Breadcrump Area */}

                {/* Start Page Wrapper */}
                <div className="rn-service-details ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="service-details-inner">
                                    <div className="inner">
                                        {/* Start Single Area */}
                                        <div className="row sercice-details-content pb--80">
                                            <div className="col-lg-6 col-12">
                                                <div className="thumb">
                                                    <img className="w-100" src="/assets/images/works/atourin/1.jpg" alt="Service Images"/>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-12">
                                                <div className="details mt_md--30 mt_sm--30">
                                                    <p>Atourin (PT Atourin Teknologi Nusantara) is a technology company in the tourism sector that provides one-stop-solution services to tourists, such as providing information on tourist attractions throughout Indonesia, recommending itineraries to various destinations, ordering tour guide services, and a marketplace filled with products local tourism.</p>
                                                    <p>Here, I offered to do mobile app developement. My job is to develop Android and IOS app using Flutter. In this project, I was building this app from the scratch and integrating it using the provided backend or API</p>
                                                    <p>The really good thing about this project is, being awarded by Google Play Store as Hidden Gem App 2022</p>

                                                    <h4 className="title">My Working Process</h4>
                                                    <ul className="liststyle">
                                                        <li>Slicing the UI using the provided UI design via Zeplin</li>
                                                        <li>Integrating it with Express.Js backend</li>
                                                        <li>Implementing features like transaction</li>
                                                        <li>Unit testing</li>
                                                        <li>Fixing visual and functional bugs</li>
                                                        <li>Publishing in Google Play Store and Apple App Store</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        {/* End Single Area */}
                                        <h2 className="text-center mb--50">Project Screenshots</h2>

                                        {/* Start Single Area */}
                                        <div className="row sercice-details-content align-items-center">
                                        <div className="col-lg-4 col-12 order-1 order-lg-2">
                                        <div className="thumb">
                                                    <img className="w-100" src="/assets/images/works/atourin/2.png" alt="Service Images"/>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-12 order-1 order-lg-2">
                                            <div className="thumb">
                                                    <img className="w-100" src="/assets/images/works/atourin/3.png" alt="Service Images"/>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-12 order-1 order-lg-2">
                                            <div className="thumb">
                                                    <img className="w-100" src="/assets/images/works/atourin/4.png" alt="Service Images"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row sercice-details-content align-items-center mt--30">
                                        <div className="col-lg-4 col-12 order-1 order-lg-2">
                                        <div className="thumb">
                                                    <img className="w-100" src="/assets/images/works/atourin/5.png" alt="Service Images"/>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-12 order-1 order-lg-2">
                                            <div className="thumb">
                                                    <img className="w-100" src="/assets/images/works/atourin/6.png" alt="Service Images"/>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-12 order-1 order-lg-2">
                                            <div className="thumb">
                                                    <img className="w-100" src="/assets/images/works/atourin/7.png" alt="Service Images"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row sercice-details-content align-items-center mt--30">
                                        <div className="col-lg-4 col-12 order-1 order-lg-2">
                                        <div className="thumb">
                                                    <img className="w-100" src="/assets/images/works/atourin/8.png" alt="Service Images"/>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-12 order-1 order-lg-2">
                                            <div className="thumb">
                                                    <img className="w-100" src="/assets/images/works/atourin/9.png" alt="Service Images"/>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-12 order-1 order-lg-2">
                                            <div className="thumb">
                                                    <img className="w-100" src="/assets/images/works/atourin/10.png" alt="Service Images"/>
                                                </div>
                                            </div>
                                        </div>
                                        {/* End Single Area */}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Page Wrapper */}
                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <FooterTwo />
            </React.Fragment>
        )
    }
}
export default Atourin;